module.exports = __webpack_public_path__ + "assets/checkbox-bg-checked.21285712.svg";